// Section Master Configuration - Combined validation rules and table configuration

// Validation rules for Section Master form fields
export const sectionMasterValidationRules = {
  section: {
    required: true,
    pattern: /^[A-Za-z0-9!@#$%&*()_+\-=\[\]{};':"\\|,.<>\/?~` ]{1,55}$/,
    message: "Section code must be up to 55 alphanumeric or special characters (except caret)"
  },
  broadHead: {
    required: true,
    minLength: 3,
    maxLength: 100,
    message: "Broad head must be between 3 and 100 characters"
  },
  startDate: {
    required: true,
    message: "Start date is required"
  },
  endDate: {
    required: false,
    message: "End date is optional"
  },
  applicableTo: {
    required: true,
    message: "Applicable To is required"
  },
  payeeStatus: {
    required: true,
    message: "Payee status is required"
  },
  thresholdAnnual: {
    required: true,
    pattern: /^\d{1,18}(\.\d{1,2})?$/,
    message: "Threshold Annual cannot be null and can maximum of 18 digits and 2 decimal places"
  },
  thresholdTransaction: {
    required: true,
    pattern: /^\d{1,18}(\.\d{1,2})?$/,
    message: "Threshold Transaction cannot be null and can maximum of 18 digits and 2 decimal places"
  },
  prescribedRate: {
    required: true,
    pattern: /^\d{1,3}(\.\d{1,2})?$/,
    message: "Prescribed Rate cannot be null and can maximum of 3 digits and 2 decimal places"
  }
};

// Editable fields configuration
export const EDITABLE_FIELDS = [
  'startDate',
  'endDate',
  'thresholdAnnual',
  'thresholdTransaction',
  'prescribedRate'
];

export const sectionMasterTableConfig = {
  title: "Section Master",

  // Table columns configuration
  columns: [
    {
      key: 'section',
      label: 'Section',
      minWidth: 140,
      isCheckboxColumn: true // This indicates this column should include the checkbox
    },
    {
      key: 'broadHead',
      label: 'Broad head',
      minWidth: 300
    },
    {
      key: 'startDate',
      label: 'Start date',
      minWidth: 150,
      editable: true
    },
    {
      key: 'endDate',
      label: 'End date',
      minWidth: 150,
      editable: true
    },
    {
      key: 'applicableTo',
      label: 'Applicable to',
      minWidth: 140
    },
    {
      key: 'payeeStatus',
      label: 'Payee status',
      minWidth: 180
    },
    {
      key: 'thresholdAnnual',
      label: 'Threshold limit (annual)',
      minWidth: 220,
      editable: true
    },
    {
      key: 'thresholdTransaction',
      label: 'Threshold limit (transaction)',
      minWidth: 220,
      editable: true
    },
    {
      key: 'prescribedRate',
      label: 'Prescribed rate (%)',
      minWidth: 200,
      editable: true
    }
  ]
};